import { Controller } from "@hotwired/stimulus";

// Muestra ✕ y oculta arrow en dropdowns con selección
export default class extends Controller {
  static targets = ["button", "arrow", "clear"];

  connect() {
    this.updateIcon();
  }

  updateIcon() {
    // const hasValue = !this.buttonTarget.innerText.trim().includes("Recurso") &&
    //                 !this.buttonTarget.innerText.trim().includes("Efector") &&
    //                 !this.buttonTarget.innerText.trim().includes("Tipo de validación");
    
    // Obtenemos el texto inicial del botón desde el label del helper
    const originalLabel = this.data.get("originalLabel");

     // hasValue es true si el texto actual del botón es diferente del original
    const hasValue = this.buttonTarget.innerText.trim() !== originalLabel;

    if (hasValue) {
      this.arrowTarget.style.display = "none";
      this.clearTarget.style.display = "inline";
      this.buttonTarget.style.backgroundColor = "#f2f2f2"; // Gris cuando tiene selección

      this.clearTarget.addEventListener("click", () => {
        this.clearFilter();
      });
    } else {
      this.arrowTarget.style.display = "inline";
      this.clearTarget.style.display = "none";
      this.buttonTarget.style.backgroundColor = "#ffffff"; // Blanco cuando vacío
    }
  }


  clearFilter() {
    const borrarLink = this.buttonTarget.nextElementSibling.querySelector("a");
    if (borrarLink) {
      borrarLink.click();
    }
  }
}

